import { GetDocumentFileById, GetDocumentFileByIdToken } from "$src/application/projects/sub/documents/queries/GetDocumentFileById";
import { GetDocumentsByProjectIdToken } from "$src/application/projects/sub/documents/queries/GetDocumentsByProjectId";
import { BlobResult } from "$src/infrastructure/network/BlobResult";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchDocumentsParams {
    queryKey: ['document-file', number, number, string];
}

export async function fetchDocument( { queryKey } : FetchDocumentsParams): Promise<BlobResult> {
    const [_, groupStoreId, projectId, documentId] = queryKey;
    const query = container.resolve<GetDocumentFileById>(GetDocumentFileByIdToken);
    return query.execute(groupStoreId, projectId, documentId);
}

export function useDocumentFile(groupStoreId: number, projectId: number, documentId: string) {
    return useQuery<BlobResult, Error, BlobResult, ['document-file', number, number, string]>(
        ['document-file', groupStoreId, projectId, documentId], 
        fetchDocument,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}